var toc_view_default = {
  "fontElementMap": "_0ALzS",
  "tocLink": "dgVE5"
};
export {
  toc_view_default as default
};
//# sourceMappingURL=toc-view-scss.js.map
